// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelAddress {
    'line1'?: string | null;
    'line2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelAddress>> = [
        {
            "name":     "line1",
            "baseName": "line1",
            "type":     "string"
        },
        {
            "name":     "line2",
            "baseName": "line2",
            "type":     "string"
        },
        {
            "name":     "city",
            "baseName": "city",
            "type":     "string"
        },
        {
            "name":     "state",
            "baseName": "state",
            "type":     "string"
        },
        {
            "name":     "zipCode",
            "baseName": "zipCode",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelAddress.attributeTypeMap;
    }
}
